"use strict";
/**
 *  timeCueModule Module
 *
 * Description 策划中心 信息监控 实时线索 近期预警
 * rebuild: SMG 2016-5-24
 */
angular.module('naturalDisasterModule', [])
    .controller('naturalDisasterController', ["$scope", "$filter", "modalDialog", "trsHttpService", "$location", "$timeout", "$q", "$element",
        function($scope, $filter, modalDialog, trsHttpService, $location, $timeout, $q, $element) {
            initStatus();
            initData();
            // var pathType = $location.path().split('/').pop();
            function initStatus() {
                $scope.data = {
                    items: "",
                    selectedEarth: [],
                    selectedWeather: [],
                    earth: "",
                    typhoon: "",
                    weather: "",
                    AllEarth: [],
                    AllWeather: [],
                    otherWarning: [],
                    keywords: "",
                    selectedEarlyWarning: [],

                    AllEarths: 0,
                    AllWeathers: 0,
                    AllEarthNub: 0,
                    AllWeatherNub: 0,

                    rightSideSelection: '',
                    chooseElement: '',
                    chooseNatureAll: []
                };
                $scope.status = {
                    jumpToPageNum: 1,
                    isSearch: false,
                    showDisasterTypes: true,
                    showEarthquake: true,
                    showWeather: true,
                    showKeywords: "",
                    pathType: $location.path().split('/').pop(),
                    chooseNature: false,
                    nowTime: $filter('date')(new Date(), "yyyy-MM-dd").toString(),
                    selectedAll: false,
                };
                $scope.page = {
                    "CURRPAGE": 0,
                    "PAGESIZE": 10
                };
                $scope.params = {
                    "serviceid": "recentdisaster",
                    "modelid": "get",
                    "page_no": $scope.page.CURRPAGE,
                    "page_size": $scope.page.PAGESIZE,
                    "search_date": "",
                    "search_word": ""
                };
                $scope.icon = {
                    iconClass: '#icon-',
                    iconColor: {
                        '蓝色': 'lan',
                        '红色': 'hong',
                        '黄色': 'huang',
                        '橙色': 'cheng'
                    },
                    iconType: {
                        '沙尘暴': 'shachenbao',
                        '森林火险': 'senlinhuoxian',
                        '霾': 'mai',
                        '雷电大风': 'leidiandafeng',
                        '雷电': 'leidian',
                        '空气重污染': 'kongqizhongwuran',
                        '降温': 'jiangwen',
                        '寒冷': 'hanleng',
                        '寒潮': 'hanchao',
                        '高温': 'gaowen',
                        '干热风': 'ganrefeng',
                        '干旱': 'ganhan',
                        '低温': 'diwen',
                        '道路结冰': 'daolujiebing',
                        '大雾': 'dawu',
                        '大风': 'dafeng',
                        '冰雹': 'bingbao',
                        '暴雨': 'baoyu',
                        '暴雪': 'baoxue',
                        '霜冻': 'shuangdong',
                    }
                };
            }

            function initData() {
                getConfig().then(function() {
                    return getUserConfig().then(function(data) {
                        $scope.data.selectedEarlyWarning = !!data ? data.split(';') : "";
                        initSelectStatus($scope.data.selectedEarlyWarning);
                        initSelectedAllStatus();
                    });
                });
                requestData();
            }

            /**
             * [searchData description查询：搜索框，根据标题、内容进行检索]
             * @return {[type]} [description]
             */
            function searchData() {
                // var pageSize = !$scope.page.PAGESIZE ? 10 : $scope.page.PAGESIZE;
                // var params = {
                //     "serviceid": "recentdisaster",
                //     "modelid": "get",
                //     "page_no": $scope.page.CURRPAGE == 0 ? 0 : $scope.page.CURRPAGE - 1,
                //     "page_size": pageSize,
                //     "search_date": $scope.params.search_date,
                //     "search_word": angular.isDefined($scope.data.keywords) ? $scope.data.keywords : ""
                // };
                $scope.params.search_word = $scope.data.keywords;
                requestData();
            }


            /**
             * [getConfig description 灾害类型和灾害级别获取]
             * @return {[type]} [description]
             */
            function getConfig() {
                var defer = $q.defer();
                var params = {
                    "serviceid": "recentdisaster",
                    "modelid": "gettenantconfig"
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    $scope.status.rightSideSelection = data;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].id == 'disaster_001') {
                            $scope.data.AllEarths = data[i].CHILDREN.length;
                        } else if (data[i].id == 'disaster_003') {
                            $scope.data.AllWeathers = data[i].CHILDREN.length;
                        }
                    }
                    if (data) {
                        getEachDisasterType(data);
                    }
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [getUserConfig 获取用户订阅的灾害级别]
             * @return {[type]} [description]
             */
            function getUserConfig() {
                var defer = $q.defer();
                var params = {
                    "serviceid": "recentdisaster",
                    "modelid": "getconfig"
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    defer.resolve(data.DISASTERTYPE);
                });
                return defer.promise;
            }
            /**
             * [getEachDisasterType description页面渲染被选中的灾害类型和灾害级别]
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function getEachDisasterType(data) {
                for (var key in data) {
                    if (key == "地震") {
                        for (var i in data[key]) {
                            if (i != "地震") {
                                $scope.data.selectedEarth.push(i);
                            }
                        }
                    }
                    if (key == "天气") {
                        for (var j in data[key]) {
                            if (j != "天气") {
                                $scope.data.selectedWeather.push(j);
                            }
                        }
                    }
                    if (key == "台风") {
                        $scope.data.typhoon = data[key];
                    }
                }
            }
            /**
             * [requestData description列表数据请求]
             * @return {[type]} [description]
             */
            function requestData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.data.items = data.PAGEITEMS;
                    $scope.page = {
                        CURRPAGE: data.PAGEINDEX + 1,
                        PAGESIZE: data.PAGESIZE,
                        ITEMCOUNT: data.TOTALITEMCOUNT,
                        PAGECOUNT: data.PAGETOTAL
                    };
                });
            }


            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.page_no = $scope.page.CURRPAGE - 1;
                $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                if ($scope.status.isSearch) {
                    searchData();
                } else {
                    requestData();
                }
                gotoTop();
            };


            $scope.jumpToPage = function() {
                if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
                    $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
                }
                $scope.params.page_no = $scope.status.jumpToPageNum - 1;
                if ($scope.status.isSearch) {
                    searchData();
                } else {
                    requestData();
                }
                gotoTop();
            };
            /**
             * [gotoTop description点击分页后，回到头部]
             * @return {[type]} [description]
             */
            function gotoTop() {
                $('html, body').animate({ scrollTop: 0 }, 'nomal');
            }
            /**
             * [brokeMonitorSearch description;根据关键词检索(包含检索的分页列表信息)]
             * @param  {[type]} ev [description:按下空格也能提交]
             */
            $scope.queryListBySearchWord = function(ev) {
                $scope.status.isSearch = true;
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.page.CURRPAGE = 0;
                    $scope.status.jumpToPageNum = 1;
                    $scope.status.showKeywords = $scope.data.keywords;
                    searchData();
                }
            };

            /**
             * [selectedDisasterTypes description 单选]
             * @param  {[type]} group [description]
             * @return {[type]}       [description]
             */
            $scope.selectedDisasterTypes = function(val, type) {
                if (type == "earth") {
                    if ($scope.data.selectedEarth.indexOf(val) < 0) {
                        $scope.data.selectedEarth.push(val);
                    } else {
                        $scope.data.selectedEarth.splice($scope.data.selectedEarth.indexOf(val), 1);
                    }
                }
                if (type == "weather") {
                    if ($scope.data.selectedWeather.indexOf(val) < 0) {
                        $scope.data.selectedWeather.push(val);
                    } else {
                        $scope.data.selectedWeather.splice($scope.data.selectedWeather.indexOf(val), 1);
                    }
                }
            };
            /**
             * [clearFiltrate 清除筛选]
             * @return {[type]} [description]
             */
            $scope.clearFiltrate = function() {
                $scope.data.selectedEarlyWarning = [];
                for (var i = 0; i < $scope.status.rightSideSelection.length; i++) {
                    $scope.status.rightSideSelection[i].isChecked = false;
                }
                $scope.status.selectedAll = false;
            };
            //单选：台风预警
            $scope.selectTyphoon = function() {
                $scope.data.typhoon = $scope.data.typhoon == '' ? '台风' : '';
            };
            //全选：地震预警
            $scope.selectAllEarth = function() {
                $scope.data.selectedEarth = $scope.data.selectedEarth.length == $scope.data.AllEarth.length ? [] : [].concat($scope.data.AllEarth);
            };
            //全选：天气预警
            $scope.selectAllWeather = function() {
                $scope.data.selectedWeather = $scope.data.selectedWeather.length == $scope.data.AllWeather.length ? [] : [].concat($scope.data.AllWeather);
            };
            /**
             * [saveAndWatch description保存并查看]
             * @return {[type]} [description]
             */
            $scope.saveAndWatch = function() {
                getDatasByConfig();
            };
            /**
             * [getDatasByConfig description用户配置信息存储，用户选择灾害类型以及灾害级别的保存]
             * @return {[type]} [description]
             */
            function getDatasByConfig() {
                var idAll = $scope.data.selectedEarlyWarning.join(';');
                if (!idAll) {
                    modalDialog.alertType("请选择灾害类别", "", "warning", false);
                    return;
                }
                $scope.data.earth = "";
                $scope.data.weather = "";
                var params = {
                    "serviceid": "recentdisaster",
                    "modelid": "saveconfig",
                    "id": idAll
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    $scope.data.items = data.PAGEITEMS;
                    $scope.page = {
                        CURRPAGE: data.PAGEINDEX + 1,
                        PAGESIZE: data.PAGESIZE,
                        ITEMCOUNT: data.TOTALITEMCOUNT,
                        PAGECOUNT: data.PAGETOTAL
                    };
                    requestData(); //rere
                });
            }
            /**
             * [getRelieveEntity description获取发布预警信息对应的解除预警信息]
             * @param  {[type]} items [description]
             * @return {[type]}       [description]
             */
            $scope.getRelieveEntity = function(item) {
                if (item.URLSTATUS != 0 || item.GROUPNAME != "天气") {
                    return;
                }
                var params = {
                    "serviceid": "recentdisaster",
                    "modelid": "getRelieveEntity",
                    "s_id": item.SID
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    if (angular.isDefined(data)) {
                        item.RelieveEntity = data;
                        if (angular.isDefined(item.RelieveEntity.URLTIME)) {
                            item.RelieveEntity.URLTIME = $filter("date")(new Date(Date.parse(item.RelieveEntity.URLTIME)), "yyyy-MM-dd HH:mm:ss").toString();
                        }
                    }
                });
            }

            /**
             * [showTitle description]鼠标移入显示标题详情
             * @param {[event]} event [description] 事件
             */
            $scope.showTitle = function(item, ev, popupwidth) {
                if (document.body.offsetWidth - ev.clientX > popupwidth) {
                    item.panelpostion = {
                        left: ev.offsetX
                    };
                } else {
                    item.panelpostion = {
                        left: 100
                    };
                }
                item.isShowTitle = true;
            };
            /**
            将日期字符串转换为时间戳
            **/
            $scope.timeStamp = function(item) {
                var date = new Date(Date.parse(item.URLTIME));
                return $filter("date")(date, "yyyy-MM-dd HH:mm:ss").toString();
            };
            /**
             * [showIcon description显示不同图标]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showIcon = function(item) {
                if (item.GROUPNAME == '天气') {
                    return $scope.icon.iconClass + $scope.icon.iconColor[item.RATE] + '-' + $scope.icon.iconType[item.WEATHER_TYPE];
                } else if (item.GROUPNAME == '地震') {
                    return $scope.icon.iconClass + 'dizhen';
                } else if (item.GROUPNAME == '台风') {
                    return $scope.icon.iconClass + 'lan-taifeng';
                }
            };

            /**
             * [setStyle description设置列表展示样式]
             * @param {[type]} item [description]
             */
            $scope.setStyle = function(item) {
                var setClass = item.RelieveEntity.URLTITLE ? 'warnings_main warnings_main_relieve' : 'warnings_main warnings_main_color';
                if (item.RATE == '其它') {
                    setClass += ' warnings_main_noIcon';
                }
                return setClass;
            };
            /**
             * [clearKeywords description清除检索条件]
             * @return {[type]} [description]
             */
            $scope.clearKeywords = function() {
                $scope.status.showKeywords = $scope.data.keywords = $scope.params.search_word = "";
                requestData();
            };
            /**
             * [getChooseTimeType description] 筛选时间
             * @return {[type]} [description]
             */
            $scope.getChooseTimeType = function() {
                $scope.params.search_date = $scope.data.fromDate + ';' + $scope.data.untilDate;
                if ($scope.params.search_date == ';') {
                    $scope.params.search_date = "";
                }
                requestData();
            };

            /**
             * [initParentSelect 设置父级全选]
             * @return {[type]} [description]
             */
            $scope.parentSelectAll = function(items) {
                var children = items.CHILDREN;
                var flag = true;
                if (!!children) { //该菜单下是否包含子菜单
                    var n = $scope.data.selectedEarlyWarning.indexOf(items.id);
                    !!items.isChecked ? $scope.data.selectedEarlyWarning.splice(n, 1) : $scope.data.selectedEarlyWarning.push(items.id);
                    for (var i = 0; i < children.length; i++) {
                        if ($scope.data.selectedEarlyWarning.indexOf(children[i].id) === -1) {
                            flag = false;
                            break;
                        }
                    }
                    if (flag) { //是否已经全选
                        if (items.isChecked) {
                            for (var i = 0; i < children.length; i++) {
                                var n = $scope.data.selectedEarlyWarning.indexOf(children[i].id);
                                if (n > -1) {
                                    $scope.data.selectedEarlyWarning.splice(n, 1);
                                } else {
                                    continue;
                                }
                            }
                            items.isChecked = false;
                        } else {
                            for (var i = 0; i < children.length; i++) {
                                var n = $scope.data.selectedEarlyWarning.indexOf(children[i].id);
                                if (n > -1) {
                                    continue;
                                } else {
                                    $scope.data.selectedEarlyWarning.push(children[i].id);
                                }
                            }
                            items.isChecked = true;
                        }
                    } else {
                        for (var i = 0; i < children.length; i++) {
                            var n = $scope.data.selectedEarlyWarning.indexOf(children[i].id);
                            if (n > -1) {
                                continue;
                            } else {
                                $scope.data.selectedEarlyWarning.push(children[i].id);
                            }
                        }
                        items.isChecked = true;
                    }
                } else {
                    var n = $scope.data.selectedEarlyWarning.indexOf(items.id);
                    if (n > -1) {
                        $scope.data.selectedEarlyWarning.splice(n, 1);
                        items.isChecked = false;
                    } else {
                        $scope.data.selectedEarlyWarning.push(items.id);
                        items.isChecked = true;
                    }
                }
                initSelectedAllStatus();
            }

            /**
             * [initParentSelectAll 父级按钮是否选中]
             * @return {[type]} [description]
             */
            $scope.initParentSelectAll = function(items) {
                var children = items.CHILDREN;
                var flag = true;
                var n = $scope.data.selectedEarlyWarning.indexOf(items.id);
                if (!!children) {
                    for (var i = 0; i < children.length; i++) {
                        if ($scope.data.selectedEarlyWarning.indexOf(children[i].id) === -1) {
                            flag = false;
                            break
                        }
                    }
                    if (flag) {
                        items.isChecked = true;
                        if (n = -1) $scope.data.selectedEarlyWarning.push(items.id);
                        return true;
                    } else {
                        items.isChecked = false;
                        if (n > -1) $scope.data.selectedEarlyWarning.splice(n, 1);
                        return false;
                    }
                } else {
                    if (!!items.isChecked) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }

            /**
             * [singleSelect 灾难预警单选]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                var n = $scope.data.selectedEarlyWarning.indexOf(item.id);
                if (n > -1) {
                    $scope.data.selectedEarlyWarning.splice(n, 1);
                } else {
                    $scope.data.selectedEarlyWarning.push(item.id);
                }
                $timeout(function() {
                    initSelectedAllStatus();
                });
            }

            /**
             * [selectAllParent 全选所有]
             * @return {[type]} [description]
             */
            $scope.selectAllParent = function() {
                if (!$scope.status.selectedAll) {
                    $scope.data.selectedEarlyWarning = [];
                    for (var i = 0; i < $scope.status.rightSideSelection.length; i++) {
                        if (!!$scope.status.rightSideSelection[i].CHILDREN && $scope.status.rightSideSelection[i].CHILDREN.length > 0) {
                            for (var k = 0; k < $scope.status.rightSideSelection[i].CHILDREN.length; k++) {
                                $scope.data.selectedEarlyWarning.push($scope.status.rightSideSelection[i].CHILDREN[k].id);
                            }
                        }
                        $scope.status.rightSideSelection[i].isChecked = true;
                        $scope.data.selectedEarlyWarning.push($scope.status.rightSideSelection[i].id);
                    }
                    $scope.status.selectedAll = true;
                } else {
                    $scope.data.selectedEarlyWarning = [];
                    for (var i = 0; i < $scope.status.rightSideSelection.length; i++) {
                        $scope.status.rightSideSelection[i].isChecked = false;
                    }
                    $scope.status.selectedAll = false;
                }
            }

            /**
             * [initSelectedAllStatus 设置全选选中状态]
             * @return {[type]} [description]
             */
            function initSelectedAllStatus() {
                var flag = true;
                for (var i = 0; i < $scope.status.rightSideSelection.length; i++) {
                    if ($scope.status.rightSideSelection[i].isChecked === false) {
                        flag = false;
                        break;
                    }
                }
                flag ? $scope.status.selectedAll = true : $scope.status.selectedAll = false;
            }

            /**
             * [initSelectStatus 获取用户保存的选项后还原到列表上]
             * @return {[type]} [description]
             */
            function initSelectStatus(status) {
                for (var i = 0; i < $scope.status.rightSideSelection.length; i++) {
                    if (status.indexOf($scope.status.rightSideSelection[i].id) > -1) {
                        $scope.status.rightSideSelection[i].isChecked = true;
                    } else {
                        $scope.status.rightSideSelection[i].isChecked = false;
                    }
                }
            }
        }
    ]);